import React from "react";
import styled from "styled-components/macro";
import { SearchBar } from "components";
import { InputSimpleDropdown } from "@loanbossinc/component-library";

import { ContactsTable } from "./";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  padding: 2em 10em;
  gap: 1em;
  min-height: 60%;
  max-width: ${(({ maxWidth }) => maxWidth)};
`;

const FilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const MCLContent = ({
  maxWidth,
  viewableContacts,
  setContactsDataToSave,
  companyOptions,
  selectedCompanyToFilter,
  setSelectedCompanyToFilter,
  searchText,
  setSearchText
}) => (
  <Container maxWidth={maxWidth}>
    <FilterWrapper>
      <InputSimpleDropdown
        name="edcContactsCompanyFilter"
        value={selectedCompanyToFilter}
        label="Filter by Company"
        options={companyOptions}
        onChange={id => setSelectedCompanyToFilter(id)}
      />
      <SearchBar
        searchText={searchText}
        setSearchText={setSearchText}
        placeholder="Search contacts by name"
      />
    </FilterWrapper>
    <ContactsTable
      viewableContacts={viewableContacts}
      setContactsDataToSave={setContactsDataToSave}
    />
  </Container>
);

export default MCLContent;
